var chunkMapping = {
	"28": [
		8028
	],
	"44": [
		44
	],
	"61": [
		1061
	],
	"106": [
		106
	],
	"209": [
		3209
	],
	"213": [
		1594
	],
	"242": [
		2242
	],
	"253": [
		1253
	],
	"390": [
		6390
	],
	"467": [
		9467
	],
	"554": [
		2554
	],
	"579": [
		8579
	],
	"581": [
		5581
	],
	"593": [
		6593
	],
	"632": [
		1632
	],
	"705": [
		4705
	],
	"797": [
		4797
	],
	"831": [
		4831
	],
	"847": [
		6847
	],
	"884": [
		1884
	]
};
var idToExternalAndNameMapping = {
	"44": [
		"default",
		"./management",
		4067
	],
	"106": [
		"default",
		"./AssistantChat",
		3169
	],
	"1061": [
		"default",
		"./dashboard",
		7306
	],
	"1253": [
		"default",
		"./vendor",
		7306
	],
	"1594": [
		"default",
		"./AISearchBar",
		3169
	],
	"1632": [
		"default",
		"./public-path",
		8119
	],
	"1884": [
		"default",
		"./public-path",
		7306
	],
	"2242": [
		"default",
		"./public-path",
		4067
	],
	"2554": [
		"default",
		"./admin",
		4067
	],
	"3209": [
		"default",
		"./vault",
		7306
	],
	"4705": [
		"default",
		"./public-path",
		671
	],
	"4797": [
		"default",
		"./public-path",
		3430
	],
	"4831": [
		"default",
		"./store",
		3430
	],
	"5581": [
		"default",
		"./AuthProvider",
		3430
	],
	"6390": [
		"default",
		"./zin",
		7306
	],
	"6593": [
		"default",
		"./public-path",
		3169
	],
	"6847": [
		"default",
		"./RequireAuth",
		3430
	],
	"8028": [
		"default",
		"./vrm",
		8119
	],
	"8579": [
		"default",
		"./documents",
		7306
	],
	"9467": [
		"default",
		"./Login",
		3430
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}